<template>
    <div class="challenge-layout">
        <div class="challenge-layout-header">
            <slot name="header" data-testing="challenge-layout-header-slot"/>
        </div>
        
        <div class="challenge-layout-form cr-mlr5">
            <slot name="form"/>
        </div>
    </div>
</template>

<style scoped>
.challenge-layout
{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.challenge-layout-header
{
    width: 100%;
}
.challenge-layout-form
{
    width: 100vw;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    padding: 15vh clamp(16px, 30vw - 80px, 25vh);
}
:deep(*):not(button[type="submit"]):not(.cr-error-text *)
{
    color: var(--cr-text);
}
:deep(.cr-error-text)
{
    color: var(--cr-error-text);
    font-size: var(--cr-caption-font-size)
}
</style>
